/**
 * Constants for Indoor Casepaper module
 */

// Initial form values for doctor round form
export const DrRoundFormInit = {
    fastingSugarLevel: '',
    PPSugarLevel: '',
    randomSugarLevel: '',
    BPMorning: '',
    BPEvening: '',
    temperature: '',
    spO2: '',
    pulse: '',
    respiratoryRate: '',
    sparshaSahatva: [
        { Yakrut: [] },
        { Pleeha: [] },
        { 'Vaam Vruka': [] },
        { 'Apan Kaksha': [] }
    ],
    naad: [],
    yakrutNada: [],
    plihaNada: [],
    Mala: [],
    Mutra: [],
    jivha: [],
    note: '',
};

// Initial medicine form values
export const medicineInit = {
    medicineName: '',
    days: null,
    whenToTake: [],
    anupan: '',
    howMuch: '',
    date: '',
};

// Round type options with labels
export const ROUND_TYPE_OPTIONS = [
    { label: '🌅 Morning Round (Before 3 PM)', value: 'morning' },
    { label: '🌆 Evening Round (3 PM - 10 PM)', value: 'evening' },
    { label: '🚨 Emergency Round (After 10 PM)', value: 'emergency' }
];

// Time thresholds for round type detection
export const ROUND_TIME_THRESHOLDS = {
    MORNING_END: 15,    // 3 PM
    EVENING_END: 22,    // 10 PM
};

// Pagination defaults
export const PAGINATION_DEFAULTS = {
    PAGE_SIZE: 10,
    INITIAL_PAGE: 1,
};

// Date display settings
export const DATE_DISPLAY = {
    VISIBLE_DATES: 2,  // Number of dates to show at once
    DATE_FORMAT: 'YYYY-MM-DD',
    DISPLAY_FORMAT: 'DD MMM YYYY',
};
